function InitializeParty()
{
  var partyId = getPartyCookie();
  function getParty(callback) {
    $.ajax({
      url: apiUrl + '/api/party/GetParty?partyId=' + partyId + "&shopUrl=" + shopUrl,
      type: "GET",
      success: function(response){
        callback(response);
      }
    });
  } 
  function getPartnerParties(callback) {
    $.ajax({
      url: apiUrl + '/api/party/GetActiveParties?webalias=' + getCookie(referralCookieName) + "&shopUrl=" + shopUrl,
      type: "GET",
      success: function(response){
        callback(response);
      }
    });
  }
  function clearPartyId(){
    document.cookie = "partyId=0; path=/";
    var nullHash = {
        'PartyId': null
    };
    $.ajax({
        type: "POST",
        url: '/cart/update.js',
        data: {attributes:nullHash},
        dataType: 'json',
        success: function(){
          var url = location.href.replace("&partyid=" + partyId, "");
          window.location = url;
        }
    });
  }
  function setPartyInfo(party){
    var html = '<span id="cartEnroller-label" class="section-heading__heading">You\'re in the party <span class="upper">' + party.description.toUpperCase() + '</span> with host <span class="upper">' + party.hostName.toUpperCase()  + ' </span></span>';
    $("#cartEnroller-label").html(html);
    $("#cartEnrollerInfo").html("");
    $("#cart-enroller-search-button").html("Want to credit a different party? Click here!")
  }
  $("#partylogin").on("click", function(){
      window.location = "/account/login?ref=" + getCookie(referralCookieName) + "&partyid=" + partyId;
  });
  $("#partycreateaccount").on("click", function(){
      window.location = "/account/register?ref=" + getCookie(referralCookieName) + "&partyid=" + partyId;
  });
  $("#partyalertcreateaccount").on("click", function(){
      window.location = "/account/register?ref=" + getCookie(referralCookieName) + "&partyid=" + partyId;
  });
  $(".partyleavebutton").on("click", function(){
      clearPartyId();
  });
  function setPartyLogic(){
    return fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      if(partyId != undefined && partyId != "0"){
        //get Party information
        getParty(function(response){
          if(response != undefined){
            //If party is found in db
            if(!response.isActive){
              $("#exigo-alert-modal-title").html("Party closed");
              $("#exigo-alert-modal-body").html("The party you are visiting is closed. Please join a different party!");
              openModal("#party-alert-modal",false);
            }
            setPartyInfo(response);
          } else {
            clearPartyId();
          }
        });
      } else {
        //If cart has partyid and there is no partyid in the cookie
        if(json.attributes.PartyId != undefined){
          //Set partyId varaible to cart value
          partyId = json.attributes.PartyId;
          getParty(function(response){
            if(response != undefined){
              //If party is found in db
              if(!response.isActive){
                $("#exigo-alert-modal-title").html("Party closed");
                $("#exigo-alert-modal-body").html("The party you are visiting is closed. Please join a different party!");
                openModal("#party-alert-modal",false);
              }
              setPartyInfo(response);
            } else {
              clearPartyId();
            }
          });
        }
      }
    })
    .catch(function (error) {
        console.error('Error retreiving cart: ', error);
        return "";
    });
  }
  $(".parties-btn").on("click", function(){
    $(".party-search-container").toggle();
    $("#partySearchResult").toggle();
  });
  var isAccountUrl = (window.location.href.toLowerCase().includes("/account"));
  if(partyId != undefined && partyId != "0" && !isCustomer && !isAccountUrl) {
    openModal("#party-login-modal",false);
  } else {
    if(!isAccountUrl) {
      console.log(partyId);
      setPartyLogic();
    }
  }
  getPartnerParties(function(response){
      if(response.length == 0) {
        $("#partySearchResult").html('<span class="enroller-no-result">No Active Parties</span>');
        $(".parties-btn").show();
      } else {
        var source = document.getElementById("party-search-result-template").innerHTML;
        var html= "";
        $.each(response, function(i,item){
          var url = "";
          if(location.href.includes("partyid=")) {
            url = location.href.replace("partyid=" + partyId, "partyid=" + item.partyId);
          } else {
            if(location.href.includes("ref=")){
              url = location.href + "&partyid=" + item.partyId;
            } else {
              url = location.href + "?ref=" + getCookie(referralCookieName) + "&partyid=" + item.partyId;
            }
          }
          item["link"] = url;
        });
        var template = Handlebars.compile(source);
        $("#partySearchResult").html(template(response));
        $(".parties-btn").show();
      }
    });
}